export const getFlightsInterlinking = (state) => state.flightsInterlinking;
